export default [
    {
        title: 'Find all your components in Octo',
        text: 'In Octo you can access components from all your Jira projects. Navigate to Octo - Component management app using the Main Jira navigation.',
        src: './gs-navigation.jpg',
    },
    {
        title: 'Create cross-project components in Octo',
        text: "You can create components using Octo's interface and assign them to one or multiple projects.\nIf you assign a component to multiple projects, the projects then share this component.",
        src: './gs-cross-project-component.gif',
    },
    {
        title: 'Merge different components together',
        text: 'If you would like to merge two components into one use the Merge components functionality. You can merge components from the same or different projects.',
        src: './gs-merge-components.gif',
    },
    {
        title: 'A better view and edit mode',
        text: 'Click on the component name to view more details. You can also quickly edit each field in this panel and all changes will be instantly saved in Jira components too.',
        src: './gs-edit-component-detail.gif',
    },
    {
        title: 'Synchronizing changes',
        text: 'Octo synchronizes with changes applied to components in Jira every 4 hours. If you want to see changes sooner, click on the Synchronize button.',
        src: './gs-synchronisation.gif',
    },
    {
        title: 'You are ready to explore!',
        text: `Click on the blue button to start using Octo.\n\nIf you are stuck, need additional information, you found a bug or you have feedback please visit our <a target="_blank" href="https://apps.appf.re/oc/support/p2">Service Desk Portal</a>.`,
        src: './blank.png',
    },
];
